import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Components
import PlanCancellationReminder from '@/components/composite/Notifications/Subscription/PlanCancellationReminder';
import PlanCancellationReminderAdmin from '@/components/composite/Notifications/Subscription/PlanCancellationReminderAdmin';
import DowngradeReminder from '@/components/composite/Notifications/Subscription/DowngradeReminder';
import DowngradeReminderAdmin from '@/components/composite/Notifications/Subscription/DowngradeReminderAdmin';
import OptionsCancellationReminder from '@/components/composite/Notifications/Subscription/OptionsCancellationReminder';
import DowngradeEffective from '@/components/composite/Notifications/Subscription/DowngradeEffective';
import OptionsCancellationEffective from '@/components/composite/Notifications/Subscription/OptionsCancellationEffective';
import RenewManualPlanReminder from '@/components/composite/Notifications/Subscription/RenewManualPlanReminder';

const NotificationsSubscription = ({ notification }: NotificationSubscriptionProps) => {
    const type = notification.type;
    switch (type) {
        case 'downgrade_being_effective':
            return <DowngradeEffective notification={notification} />;
        case 'downgrade_reminder':
            return <DowngradeReminder notification={notification} />;
        case 'downgrade_reminder_admin':
            return <DowngradeReminderAdmin notification={notification} />;
        case 'options_cancellation_being_effective':
            return <OptionsCancellationEffective notification={notification} />;
        case 'options_cancellation_reminder':
            return <OptionsCancellationReminder notification={notification} />;
        case 'plan_cancellation_reminder':
            return <PlanCancellationReminder notification={notification} />;
        case 'plan_cancellation_reminder_admin':
            return <PlanCancellationReminderAdmin notification={notification} />;
        case 'renew_reminder_manual_plans':
            return <RenewManualPlanReminder notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsSubscription;
